var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutLinkImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_2720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98512 9.14823H0.372043L2.83122 7.41313H5.62572L3.98512 9.14823ZM14.0151 9.14823H17.6281L15.169 7.41313H12.3744L14.0151 9.14823ZM7.05753 18.5H8.62831V13.329H7.05753V18.5ZM9.20895 18.5H10.7797V13.329H9.20895V18.5ZM17.9367 9.72887V18.5H11.3604V13.0387V12.7484H11.0701H9.20895H8.62831H6.76721H6.47689V13.0387V18.5H0.0634766V9.72887H4.23522L6.61766 7.20922L8.70977 4.99662V0.5H9.29041H12.4737L12.3241 0.597383L10.6438 1.69155L12.3241 2.78575L12.4737 2.8831H9.29041V4.99659L11.3825 7.20918L13.765 9.72883H17.9367V9.72887ZM2.84374 15.6204H1.18883V17.2753H2.84374V15.6204ZM2.84374 13.0387H1.18883V14.6936H2.84374V13.0387ZM5.49164 15.6204H3.83673V17.2753H5.49164V15.6204ZM5.49164 13.0387H3.83673V14.6936H5.49164V13.0387ZM10.3571 9.92743C10.3571 9.17797 9.74955 8.5704 9.00009 8.5704C8.25063 8.5704 7.64306 9.17797 7.64306 9.92743C7.64306 10.6769 8.25063 11.2845 9.00009 11.2845C9.74955 11.2845 10.3571 10.6769 10.3571 9.92743ZM14.1635 15.6204H12.5085V17.2753H14.1635V15.6204ZM14.1635 13.0387H12.5085V14.6936H14.1635V13.0387ZM16.8114 15.6204H15.1564V17.2753H16.8114V15.6204ZM16.8114 13.0387H15.1564V14.6936H16.8114V13.0387Z",
    fill: "#D31C4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_2720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLinkImg);
export default __webpack_public_path__ + "static/media/aboutLinkImg.fb5af28139c2483cf6222813dbde94e5.svg";
export { ForwardRef as ReactComponent };